import { measureApi } from '@/api/config-setup'
import { queryKeys } from '@/constant/common'
import { MEASURE } from '@/types'
import { useQuery } from '@tanstack/react-query'

const useMeasureOptions = () => {
  return useQuery(
    [queryKeys.measureOptions],
    async () => {
      return await measureApi.getAll()
        .then(res => res.data)
        .catch(() => [] as MEASURE[])
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    })
}

export default useMeasureOptions
